export class ErrorHandle {
  static default(...args) {}
}
